module.exports = __webpack_public_path__ + "img/gsxw_5.b91822f8.png";